import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import {
  COUNTRY_OPTIONS,
  ITEM_VOLUME_OPTIONS,
  getFreightClassOptions,
  ITEM_COMMODITY_OPTIONS,
  ITEM_DIMENSIONS_OPTIONS,
  ITEM_TEMPERATURE_OPTIONS,
  ITEM_ODOMETER_UOM_OPTIONS,
  ITEM_HAZMAT_CLASS_OPTIONS,
  TEMPERATURE_SENSOR_OPTIONS,
  ITEM_TEMPERATURE_TYPE_OPTIONS,
  DEFAULT_ITEM_WEIGHT_UOM_OPTIONS,
  ITEM_HAZMAT_PACKAGE_GROUP_OPTIONS,
  DEFAULT_QUANTITY_RATE_UNIT_OPTIONS,
} from '../../../helpers/options';
//////////////////////////////////////////////////

export const itemEmptyFields = {
  [GC.FIELD_ITEM_ID]: '',
  [GC.FIELD_TAPA]: false,
  [GC.FIELD_ITEM_TYPE]: '',
  [GC.FIELD_PO_NUMBER]: '',
  [GC.FIELD_PHARMA]: false,
  [GC.FIELD_CASE_COUNT]: '',
  [GC.FIELD_ITEM_WEIGHT]: '',
  [GC.FIELD_DESCRIPTION]: '',
  [GC.FIELD_ITEM_VOLUME]: '',
  [GC.FIELD_ITEM_N_M_F_C]: '',
  [GC.FIELD_ITEM_QUANTITY]: '',
  [GC.FIELD_PALLET_SPACES]: '',
  [GC.FIELD_ITEM_COMMODITY]: '',
  [GC.FIELD_BILLABLE_WEIGHT]: '',
  [GC.FIELD_ORIGIN_OF_GOODS]: '',
  [GC.FIELD_ITEM_VOLUME_UOM]: '',
  [GC.FIELD_ITEM_WEIGHT_TYPE]: '',
  [GC.FIELD_HIGH_SECURITY]: false,
  [GC.FIELD_ITEM_PACKAGE_TYPE]: '',
  [GC.FIELD_ITEM_DECLARED_VALUE]: '',
  [GC.FIELD_ITEM_DIMENSIONS_UOM]: '',
  [GC.FIELD_ITEM_MONETARY_VALUE]: '',
  [GC.FIELD_ITEM_TEMPERATURE_LOW]: '',
  [GC.FIELD_ITEM_TEMPERATURE_UOM]: '',
  [GC.FIELD_ITEM_TEMPERATURE_TYPE]: '',
  [GC.FIELD_ITEM_STACKABILITY]: false,
  [GC.FIELD_CONTAINER_INTERNAL_ID]: '',
  [GC.FIELD_ITEM_TEMPERATURE_HIGH]: '',
  [GC.FIELD_ITEM_DIMENSIONS_LENGTH]: '',
  [GC.FIELD_ITEM_DIMENSIONS_WIDTH]: '',
  [GC.FIELD_ITEM_DIMENSIONS_HEIGHT]: '',
  [GC.FIELD_ITEM_DECLARED_CURRENCY]: '',
  [GC.FIELD_ITEM_CUSTOMER_PART_NUMBER]: '',
  [GC.FIELD_ITEM_STACKABILITY_CONDITION]: '',
  [GC.FIELD_ITEM_MONETARY_VALUE_CURRENCY]: '',
  // hazmat
  [GC.FIELD_ITEM_HAZARDOUS]: false,
  [GC.FIELD_ITEM_HAZMAT_CLASS]: '',
  [GC.FIELD_ITEM_HAZMAT_COMMENT]: '',
  [GC.FIELD_ITEM_HAZMAT_FLASHPOINT]: '',
  [GC.FIELD_ITEM_HAZMAT_EMS_NUMBER]: '',
  [GC.FIELD_ITEM_HAZMAT_PLACARDS]: false,
  [GC.FIELD_ITEM_HAZMAT_CONTACT_NAME]: '',
  [GC.FIELD_ITEM_HAZMAT_SHIPPING_NAME]: '',
  [GC.FIELD_ITEM_HAZMAT_CONTACT_PHONE]: '',
  [GC.FIELD_ITEM_HAZMAT_PACKAGE_GROUP]: '',
  [GC.FIELD_ITEM_HAZMAT_FLASHPOINT_UOM]: '',
  [GC.FIELD_ITEM_HAZMAT_UN_OR_NA_NUMBER]: '',
  [GC.FIELD_ITEM_HAZMAT_PLACARDS_DETAILS]: '',
  // car hauler
  [GC.FIELD_VIN]: '',
  [GC.FIELD_BAY]: '',
  [GC.FIELD_YEAR]: '',
  [GC.FIELD_MAKE]: '',
  [GC.FIELD_MODEL]: '',
  [GC.FIELD_COLOR]: '',
  [GC.FIELD_ODOMETER]: '',
  [GC.FIELD_SUB_MODEL]: '',
  [GC.FIELD_WHEELBASE]: '',
  [GC.FIELD_ODOMETER_UOM]: '',
  [GC.FIELD_MANUFACTURER]: '',
  [GC.FIELD_ORIGIN_STATE]: '',
  [GC.FIELD_WHEELBASE_UOM]: '',
  [GC.FIELD_LICENSE_PLATE]: '',
  [GC.FIELD_ORIGIN_COUNTRY]: '',
  [GC.FIELD_OPERATIONAL]: false,
};

export const getNewItemFields = (branchConfigs) => {
  const branchItemValues = G.mapObjectNullFieldsToEmptyStrings(
    G.getDefaultBranchCloItemValuesFromConfigs(branchConfigs),
  );

  return {
    ...itemEmptyFields,
    ...branchItemValues,
    [GC.FIELD_ITEM_INTERNAL_ID]: G.generateGuid(),
  };
};

const itemCommonProps1 = {
  inputWrapperStyles: {
    mr: 20,
    mb: 30,
    width: 100,
  },
};

const itemCommonProps2 = {
  width: 160,
  inputWrapperStyles: {
    mr: 20,
    mb: 30,
    width: 160,
  },
};

const itemCommonProps3 = {
  inputWrapperStyles: {
    mr: 20,
    mb: 30,
    width: 120,
  },
};

const pickupItemHazmatRejectFieldNames = [
  GC.FIELD_TAPA,
  GC.FIELD_PHARMA,
  GC.FIELD_HIGH_SECURITY,
  GC.FIELD_ITEM_HAZARDOUS,
  GC.FIELD_ITEM_HAZMAT_CLASS,
  GC.FIELD_ITEM_HAZMAT_COMMENT,
  GC.FIELD_ITEM_HAZMAT_PLACARDS,
  GC.FIELD_ITEM_HAZMAT_EMS_NUMBER,
  GC.FIELD_ITEM_HAZMAT_FLASHPOINT,
  GC.FIELD_ITEM_HAZMAT_CONTACT_NAME,
  GC.FIELD_ITEM_HAZMAT_SHIPPING_NAME,
  GC.FIELD_ITEM_HAZMAT_PACKAGE_GROUP,
  GC.FIELD_ITEM_HAZMAT_CONTACT_PHONE,
  GC.FIELD_ITEM_HAZMAT_FLASHPOINT_UOM,
  GC.FIELD_ITEM_HAZMAT_UN_OR_NA_NUMBER,
  GC.FIELD_ITEM_HAZMAT_PLACARDS_DETAILS,
];

export const pickupItemStopGroups = {
  searchByItemId: {
    fields: [
      {
        width: 250,
        type: 'asyncSearch',
        fieldName: GC.FIELD_ITEM_ID,
        inputWrapperStyles: { mb: 30, width: 250 },
        placeholder: G.getWindowLocale('titles:search', 'Search'),
        label: G.getWindowLocale('titles:search-by-item-id', 'Search by Item ID'),
      },
    ],
  },
  general: {
    fields: [
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: true,
        fieldName: GC.FIELD_ITEM_ID,
        label: G.getWindowLocale('titles:item-id', 'Item ID'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: true,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_WEIGHT,
        label: G.getWindowLocale('titles:weight', 'Weight'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: true,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_WEIGHT_TYPE,
        options: DEFAULT_ITEM_WEIGHT_UOM_OPTIONS,
        label: G.getWindowLocale('titles:uom', 'UOM'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        shouldCustomChange: true,
        options: 'itemContainerOptions',
        fieldName: GC.FIELD_CONTAINER_INTERNAL_ID,
        label: G.getWindowLocale('titles:container', 'Container'),
        customChangeHandler: (event, field, props) => {
          const { values, itemIndex, setFieldValue } = props;

          const value = G.getEventTargetValue(event);

          const items = G.getPropFromObject(GC.FIELD_STOP_ITEMS, values);
          const currentValues = G.getPropFromObject(itemIndex, items);

          const newValues = R.mergeRight(currentValues, {
            [GC.FIELD_CONTAINER_GUID]: null,
            [GC.FIELD_CONTAINER_INTERNAL_ID]: value,
          });

          const updatedItems = R.update(itemIndex, newValues, items);

          return setFieldValue(GC.FIELD_STOP_ITEMS, updatedItems);
        },
      },
      {
        ...itemCommonProps2,
        type: 'text',
        fieldName: GC.FIELD_DESCRIPTION,
        rejectFieldName: GC.FIELD_DESCRIPTION,
        label: G.getWindowLocale('titles:description', 'Description'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_QUANTITY,
        rejectFieldName: GC.FIELD_ITEM_QUANTITY,
        label: G.getWindowLocale('titles:quantity', 'Quantity'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_PACKAGE_TYPE,
        rejectFieldName: GC.FIELD_ITEM_QUANTITY,
        options: DEFAULT_QUANTITY_RATE_UNIT_OPTIONS,
        label: G.getWindowLocale('titles:uom', 'UOM'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        shouldCustomChange: true,
        fieldName: GC.FIELD_PALLET_SPACES,
        rejectFieldName: GC.FIELD_PALLET_SPACES,
        label: G.getWindowLocale('titles:pallet-spaces', 'Pallet Spaces'),
        customChangeHandler: ({ target }, field, props) => {
          const { values, itemIndex, setFieldValue, branchConfigs } = props;

          const value = G.getValueFromObject(target);

          const items = R.prop(GC.FIELD_STOP_ITEMS, values);
          const currentValues = R.path([GC.FIELD_STOP_ITEMS, itemIndex], values);

          const configBillableWeight = G.getConfigValueFromStore(
            GC.CLO_ITEM_BILLABLE_WEIGHT_PER_PALLET_SPACE,
            branchConfigs,
          );

          let newValues = R.assoc(GC.FIELD_PALLET_SPACES, value, currentValues);

          if (G.isNilOrEmpty(configBillableWeight)) {
            return setFieldValue(GC.FIELD_STOP_ITEMS, R.update(itemIndex, newValues, items));
          }

          const billableWeight = G.calculateBillableWeight(value, configBillableWeight);

          newValues = R.assoc(GC.FIELD_BILLABLE_WEIGHT, R.or(billableWeight, ''), newValues);

          return setFieldValue(GC.FIELD_STOP_ITEMS, R.update(itemIndex, newValues, items));
        },
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_BILLABLE_WEIGHT,
        rejectFieldName: GC.FIELD_BILLABLE_WEIGHT,
        label: G.getWindowLocale('titles:billable-weight', 'Billable Weight'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_CASE_COUNT,
        rejectFieldName: GC.FIELD_CASE_COUNT,
        label: G.getWindowLocale('titles:case-count', 'Case Count'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        options: getFreightClassOptions(),
        fieldName: GC.FIELD_ITEM_FREIGHT_CLASS,
        rejectFieldName: GC.FIELD_ITEM_FREIGHT_CLASS,
        label: G.getWindowLocale('titles:freight-class', 'Freight Class'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_MONETARY_VALUE,
        rejectFieldName: GC.FIELD_ITEM_MONETARY_VALUE,
        label: G.getWindowLocale('titles:monetary-value', 'Monetary Value'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        options: GC.CURRENCY_OPTIONS_2,
        rejectFieldName: GC.FIELD_ITEM_MONETARY_VALUE,
        fieldName: GC.FIELD_ITEM_MONETARY_VALUE_CURRENCY,
        label: G.getWindowLocale('titles:currency', 'Currency'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_PO_NUMBER,
        rejectFieldName: GC.FIELD_PO_NUMBER,
        label: G.getWindowLocale('titles:po-number', 'PO Number'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_N_M_F_C,
        rejectFieldName: GC.FIELD_ITEM_N_M_F_C,
        label: G.getWindowLocale('titles:nmfc', 'NMFC'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        fieldName: GC.FIELD_ORIGIN_OF_GOODS,
        rejectFieldName: GC.FIELD_ORIGIN_OF_GOODS,
        options: G.prependEmptyLabelValueOption(COUNTRY_OPTIONS),
        label: G.getWindowLocale('titles:origin-of-goods', 'Origin Of Goods'),
      },
      // car hauler
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_MANUFACTURER,
        rejectFieldName: GC.FIELD_MANUFACTURER,
        label: G.getWindowLocale('titles:manufacturer', 'Manufacturer'),
      },
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_OPERATIONAL,
        rejectFieldName: GC.FIELD_OPERATIONAL,
        label: G.getWindowLocale('titles:operational', 'Operational'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_YEAR,
        rejectFieldName: GC.FIELD_YEAR,
        label: G.getWindowLocale('titles:year', 'Year'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_MAKE,
        rejectFieldName: GC.FIELD_MAKE,
        label: G.getWindowLocale('titles:make', 'Make'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_MODEL,
        rejectFieldName: GC.FIELD_MODEL,
        label: G.getWindowLocale('titles:model', 'Model'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_SUB_MODEL,
        rejectFieldName: GC.FIELD_SUB_MODEL,
        label: G.getWindowLocale('titles:sub-model', 'Submodel'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_WHEELBASE,
        rejectFieldName: GC.FIELD_WHEELBASE,
        label: G.getWindowLocale('titles:wheelbase', 'Wheelbase'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        options: ITEM_DIMENSIONS_OPTIONS,
        fieldName: GC.FIELD_WHEELBASE_UOM,
        rejectFieldName: GC.FIELD_WHEELBASE,
        label: G.getWindowLocale('titles:wheelbase-uom', 'Wheelbase UOM'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_BAY,
        rejectFieldName: GC.FIELD_BAY,
        label: G.getWindowLocale('titles:bay', 'Bay'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_ODOMETER,
        rejectFieldName: GC.FIELD_ODOMETER,
        label: G.getWindowLocale('titles:odometer', 'Odometer'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        fieldName: GC.FIELD_ODOMETER_UOM,
        rejectFieldName: GC.FIELD_ODOMETER,
        options: ITEM_ODOMETER_UOM_OPTIONS,
        label: G.getWindowLocale('titles:odometer-uom', 'Odometer UOM'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_DECLARED_VALUE,
        rejectFieldName: GC.FIELD_ITEM_DECLARED_VALUE,
        label: G.getWindowLocale('titles:declared-value', 'Declared Value'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        options: GC.CURRENCY_OPTIONS_2,
        fieldName: GC.FIELD_ITEM_DECLARED_CURRENCY,
        rejectFieldName: GC.FIELD_ITEM_DECLARED_VALUE,
        label: G.getWindowLocale('titles:currency', 'currency'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_COLOR,
        rejectFieldName: GC.FIELD_COLOR,
        label: G.getWindowLocale('titles:color', 'Color'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_LICENSE_PLATE,
        rejectFieldName: GC.FIELD_LICENSE_PLATE,
        label: G.getWindowLocale('titles:license-plate', 'License Plate'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_VIN,
        rejectFieldName: GC.FIELD_VIN,
        label: G.getWindowLocale('titles:vin', 'VIN'),
      },
    ],
  },
  dimensionsL: {
    rejectFieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
    fields: [
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
        rejectFieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
        label: G.getWindowLocale('titles:dimensions-l', 'Dimensions L'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_DIMENSIONS_WIDTH,
        rejectFieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
        label: G.getWindowLocale('titles:dimensions-w', 'Dimensions W'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        shouldCustomChange: true,
        fieldName: GC.FIELD_ITEM_DIMENSIONS_HEIGHT,
        rejectFieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
        label: G.getWindowLocale('titles:dimensions-l', 'Dimensions H'),
      },
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        shouldCustomChange: true,
        options: ITEM_DIMENSIONS_OPTIONS,
        fieldName: GC.FIELD_ITEM_DIMENSIONS_UOM,
        label: G.getWindowLocale('titles:uom', 'UOM'),
        rejectFieldName: GC.FIELD_ITEM_DIMENSIONS_LENGTH,
      },
    ],
  },
  cubicCapacity: {
    rejectFieldName: 'cubicCapacity',
    fields: [
      {
        ...itemCommonProps3,
        type: 'text',
        disabled: true,
        fieldName: 'cubicVolume',
        rejectFieldName: 'cubicCapacity',
        label: G.getWindowLocale('titles:cubic-volume', 'Cubic Volume'),
      },
      {
        ...itemCommonProps3,
        type: 'text',
        disabled: true,
        fieldName: 'cubicDensity',
        rejectFieldName: 'cubicCapacity',
        label: G.getWindowLocale('titles:cubic-density', 'Cubic Density'),
      },
    ],
  },
  temperature: {
    rejectFieldName: [GC.FIELD_ITEM_TEMPERATURE_LOW, GC.FIELD_ITEM_TEMPERATURE_TYPE],
    fields: [
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        options: ITEM_TEMPERATURE_TYPE_OPTIONS,
        fieldName: GC.FIELD_ITEM_TEMPERATURE_TYPE,
        rejectFieldName: GC.FIELD_ITEM_TEMPERATURE_TYPE,
        label: G.getWindowLocale('titles:temperature-type', 'Temperature Type'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_TEMPERATURE_LOW,
        rejectFieldName: GC.FIELD_ITEM_TEMPERATURE_LOW,
        label: G.getWindowLocale('titles:temperature-low', 'Temperature Low'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_TEMPERATURE_HIGH,
        rejectFieldName: GC.FIELD_ITEM_TEMPERATURE_LOW,
        label: G.getWindowLocale('titles:temperature-high', 'Temperature High'),
      },
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        options: ITEM_TEMPERATURE_OPTIONS,
        fieldName: GC.FIELD_ITEM_TEMPERATURE_UOM,
        label: G.getWindowLocale('titles:uom', 'UOM'),
        rejectFieldName: GC.FIELD_ITEM_TEMPERATURE_LOW,
      },
    ],
  },
  volume: {
    fields: [
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_VOLUME,
        rejectFieldName: GC.FIELD_ITEM_VOLUME,
        label: G.getWindowLocale('titles:volume', 'Volume'),
      },
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        options: ITEM_VOLUME_OPTIONS,
        fieldName: GC.FIELD_ITEM_VOLUME_UOM,
        rejectFieldName: GC.FIELD_ITEM_VOLUME,
        label: G.getWindowLocale('titles:uom', 'UOM'),
      },
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        options: ITEM_COMMODITY_OPTIONS,
        fieldName: GC.FIELD_ITEM_COMMODITY,
        rejectFieldName: GC.FIELD_ITEM_COMMODITY,
        label: G.getWindowLocale('titles:commodity', 'Commodity'),
      },
      {
        ...itemCommonProps1,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_CUSTOMER_PART_NUMBER,
        rejectFieldName: GC.FIELD_ITEM_CUSTOMER_PART_NUMBER,
        label: G.getWindowLocale('titles:part-num', 'Part Number'),
      },
    ],
  },
  stackability: {
    rejectFieldName: [GC.FIELD_ITEM_STACKABILITY, GC.FIELD_ITEM_TEMPERATURE_SENSOR],
    fields: [
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_ITEM_STACKABILITY,
        rejectFieldName: GC.FIELD_ITEM_STACKABILITY,
        label: G.getWindowLocale('titles:stackability', 'Stackability'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        rejectFieldName: GC.FIELD_ITEM_STACKABILITY,
        fieldName: GC.FIELD_ITEM_STACKABILITY_CONDITION,
        label: G.getWindowLocale('titles:stackability-condition', 'Stackability Condition'),
      },
      {
        ...itemCommonProps3,
        type: 'select',
        isRequired: false,
        options: TEMPERATURE_SENSOR_OPTIONS,
        fieldName: GC.FIELD_ITEM_TEMPERATURE_SENSOR,
        rejectFieldName: GC.FIELD_ITEM_TEMPERATURE_SENSOR,
        label: G.getWindowLocale('titles:temperature-sensor', 'Temperature Sensor'),
      },
    ],
  },
  hazmat: {
    rejectFieldName: pickupItemHazmatRejectFieldNames,
    fields: [
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_ITEM_HAZARDOUS,
        rejectFieldName: GC.FIELD_ITEM_HAZARDOUS,
        label: G.getWindowLocale('titles:hazardous', 'Hazardous'),
      },
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_TAPA,
        rejectFieldName: GC.FIELD_TAPA,
        label: G.getWindowLocale('titles:tapa', 'TAPA'),
      },
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_HIGH_SECURITY,
        rejectFieldName: GC.FIELD_HIGH_SECURITY,
        label: G.getWindowLocale('titles:high-sequrity', 'High Sequrity'),
      },
      {
        ...itemCommonProps1,
        type: 'checkbox',
        fieldName: GC.FIELD_PHARMA,
        rejectFieldName: GC.FIELD_PHARMA,
        label: G.getWindowLocale('titles:pharma', 'Pharma'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_UN_OR_NA_NUMBER,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_UN_OR_NA_NUMBER,
        label: G.getWindowLocale('titles:hazmat-un-or-na-number', 'HazMat UN or NA Number'),
      },
      {
        ...itemCommonProps2,
        type: 'select',
        isRequired: false,
        options: ITEM_HAZMAT_PACKAGE_GROUP_OPTIONS,
        fieldName: GC.FIELD_ITEM_HAZMAT_PACKAGE_GROUP,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_PACKAGE_GROUP,
        label: G.getWindowLocale('titles:hazmat-package-group', 'HazMat Package Group'),
      },
      {
        ...itemCommonProps2,
        type: 'select',
        isRequired: false,
        options: ITEM_HAZMAT_CLASS_OPTIONS,
        fieldName: GC.FIELD_ITEM_HAZMAT_CLASS,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_CLASS,
        label: G.getWindowLocale('titles:hazmat-class', 'HazMat Class'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_SHIPPING_NAME,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_SHIPPING_NAME,
        label: G.getWindowLocale('titles:hazmat-shipping-name', 'HazMat Shipping Name'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_CONTACT_NAME,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_CONTACT_NAME,
        label: G.getWindowLocale('titles:hazmat-contact-name', 'HazMat Contact Name'),
      },
      {
        ...itemCommonProps2,
        type: 'phoneNumber',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_CONTACT_PHONE,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_CONTACT_PHONE,
        label: G.getWindowLocale('titles:hazmat-contact-phone', 'HazMat Contact Phone'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_EMS_NUMBER,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_EMS_NUMBER,
        label: G.getWindowLocale('titles:hazmat-ems-number', 'HazMat EMS Number'),
      },
      {
        ...itemCommonProps3,
        type: 'checkbox',
        fieldName: GC.FIELD_ITEM_HAZMAT_PLACARDS,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_PLACARDS,
        label: G.getWindowLocale('titles:hazmat-placards', 'HazMat Placards'),
      },
      {
        ...itemCommonProps2,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_PLACARDS_DETAILS,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_PLACARDS_DETAILS,
        label: G.getWindowLocale('titles:hazmat-placard-details', 'HazMat Placard Details'),
      },
      {
        ...itemCommonProps1,
        type: 'number',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_FLASHPOINT,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_FLASHPOINT,
        label: G.getWindowLocale('titles:hazmat-flashpoint', 'HazMat Flashpoint'),
      },
      {
        ...itemCommonProps1,
        type: 'select',
        isRequired: false,
        options: ITEM_TEMPERATURE_OPTIONS,
        label: G.getWindowLocale('titles:uom', 'UOM'),
        fieldName: GC.FIELD_ITEM_HAZMAT_FLASHPOINT_UOM,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_FLASHPOINT,
      },
      {
        width: 250,
        type: 'text',
        isRequired: false,
        fieldName: GC.FIELD_ITEM_HAZMAT_COMMENT,
        rejectFieldName: GC.FIELD_ITEM_HAZMAT_COMMENT,
        inputWrapperStyles: { mr: 20, mb: 30, width: 250 },
        label: G.getWindowLocale('titles:hazmat-comments', 'Hazmat Comments'),
      },
    ],
  },
};

export const dropItemStopFields = [
  {
    isMulti: true,
    isRequired: true,
    type: 'reactSelect',
    shouldValidate: true,
    inputWrapperStyles: {
      mr: 20,
      zIndex: 20,
      width: 400,
    },
    closeMenuOnSelect: false,
    options: GC.FIELD_LOAD_ITEMS,
    fieldName: GC.FIELD_LOAD_ITEMS,
    label: G.getWindowLocale('titles:items', 'items'),
  },
];
